import React, { useState } from "react";
import InputField from "../../../core/common/form-fields/InputField";
import { ErrorType } from "../../../types/common-type";
import { validateForm } from "../../../core/validations/Validation_singleInvite";
import { InputDateField } from "../../../core/common/form-fields/InputDateField";
import handleClearError from "../../../core/methods/handleClearError";
import ErrorMessage from "../../../core/common/ErrorMessage";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import { OrderFilterProps } from "./AssignOrderToCandidate";
import Swal from "sweetalert2";
import CommonFilterSelect, {
  FilterTypes,
  initialFilters,
} from "../../../core/common/CommonFilterSelect";
import { usePackageByDepartmentId } from "../../../core/customhook/hooks/packageHooks";
import "./ReviewCandidateModal.css";
 

const initialState = {
  first_name: "",
  middle_name: "",
  last_name: "",
  applicant_email: "",
  applicant_mobile: "",
  dob: "",
  gender: "",
  parent_name: "",
  uan_no: "",
  aadharNumber: "",
  pan_no: "",
  address1: "",
  address2: "",
  crn_no: "",
  hrmsId: "",
  employeeId: "",
  joiningDate: "",
  spocName: "",
  aadhar_pincode: "",
  address_pincode: "",
};

interface SingleProps {
  orderFilter: OrderFilterProps;
  orderId: string | undefined;
}

const SingleAssign = ({ orderFilter, orderId = "" }: SingleProps) => {
  const [errors, setErrors] = useState<ErrorType | null>(null);
  const [formData, setFormData] = useState(initialState);
  const { callApi, loading: loadingCreate } = useApi<any>("", {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  console.log("orderFilter", orderFilter);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
    handleClearError(setErrors, name);
  };
  const handleDateChange = (name: string, value: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    handleClearError(setErrors, name);
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!orderId) return;

    const isValid = validateForm({ formData, setErrors });
    if (!isValid) return;

    try {
      const payload = {
        org_id: selectedOrgId,
        order_id: orderId ?? "",
        project_id: orderFilter?.project_id,
        package_id: orderFilter?.package_id,
        program_id: orderFilter?.program_id,
        department_id: orderFilter?.department_id, 
        firstName: formData.first_name.trim(),
        middleName: formData.middle_name.trim(),
        lastName: formData.last_name.trim(),
        applicantEmailId: formData.applicant_email.trim(),
        applicantMobileNumber: formData.applicant_mobile.trim(),
        dateOfBirth: formData.dob,
        gender: formData.gender,
        fatherNameMotherName: formData.parent_name.trim(), 
        uan_no: formData.uan_no.trim(),
        aadharNumber: formData.aadharNumber.trim(),
        pan_no: formData.pan_no.trim().toUpperCase(), 
        address1: formData.address1.trim(),
        address2: formData.address2.trim(),
        address_pincode: formData.address_pincode.trim(),
        aadhar_pincode: formData.aadhar_pincode.trim(), 
        crn_no: formData.crn_no.trim(),
        hrmsId: formData.hrmsId.trim(),
        employeeId: formData.employeeId.trim(),
        joiningDate: formData.joiningDate,
        spocName: formData.spocName.trim(),
      };
      const res = await callApi(
        payload,
        `${webservice_url.assignOrderToSingleCase}/${orderId}`,
      );

      if (res?.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: res?.message || "Invite created successfully!",
          confirmButtonText: "OK",
          confirmButtonColor: "#f26522",
        });

        setFormData(initialState);
      }
    } catch (error: any) {
      console.error("Submission failed:", error);

      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Invite failed";

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: message,
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
    }
  };

  const sharedProps = {
    data: formData,
    onChange: handleChange,
    colClass: "col-6 col-md-4",
    errors: errors,
  };
  const [filterData, setFilterData] = useState<FilterTypes>(initialFilters);

  const { selectedItem: selectedPackage, loading: loadingPackage } =
    usePackageByDepartmentId(filterData?.department, filterData?.package);

  const getSelectedValue = (value: any): string => {
    if (value == null) return "";

    if (typeof value === "object") {
      return String(
        value.value ??
          value.id ??
          value.org_id ??
          value.project_id ??
          value.program_id ??
          value.department_id ??
          value.package_id ??
          "",
      );
    }

    return String(value);
  };

  const selectedOrgId = getSelectedValue(
    filterData?.organization ?? (filterData as any)?.org_id,
  );

  const selectedProjectId = getSelectedValue(filterData?.project);
  const selectedProgramId = getSelectedValue(filterData?.program);
  const selectedDepartmentId = getSelectedValue(filterData?.department);
  const selectedPackageId = getSelectedValue(filterData?.package);

  const hasOrderConfiguration = Boolean( 
    orderFilter?.program_id?.trim() &&
    orderFilter?.department_id?.trim() &&
    orderFilter?.package_id?.trim(),
  );

  console.log("Order configuration:", { 
    program_id: orderFilter?.program_id,
    department_id: orderFilter?.department_id,
    package_id: orderFilter?.package_id,
    hasOrderConfiguration,
  });

  return (
    <div className="px-2 px-md-3 ">
      <div className="fw-semibold text-dark mb-3 pt-sm-2">Step 1</div>

      {hasOrderConfiguration ? (
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden order-config-card">
          <div className="order-config-header d-flex align-items-center justify-content-between flex-wrap gap-2 px-4 py-3">
            <div className="d-flex align-items-center gap-3">
              <div className="order-config-icon">
                <i className="ti ti-clipboard-check"></i>
              </div>
              <div>
                <h5 className="mb-1 fw-bold text-dark">Order Configuration</h5>
                <p className="mb-0 text-muted small">
                  Review the account and package details for this order.
                </p>
              </div>
            </div>
            <span className="order-config-badge">
              <i className="ti ti-circle-check me-1"></i>
              Configuration Loaded
            </span>
          </div>

          <div className="card-body p-3 p-md-4">
            <div className="row g-3">
              <div className="col-12 col-md-6 col-xl-4">
                <div className="order-config-item h-100">
                  <div className="order-config-item-icon">
                    <i className="ti ti-building-community"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="order-config-label">Organization</div>
                    <div className="order-config-value">
                      {orderFilter?.organization || "-"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-xl-4">
                <div className="order-config-item h-100">
                  <div className="order-config-item-icon">
                    <i className="ti ti-briefcase-2"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="order-config-label">Account</div>
                    <div className="order-config-value">
                      {orderFilter?.project || "-"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-xl-4">
                <div className="order-config-item h-100">
                  <div className="order-config-item-icon">
                    <i className="ti ti-map-pin"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="order-config-label">Location</div>
                    <div className="order-config-value">
                      {orderFilter?.location || "-"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-xl-4">
                <div className="order-config-item h-100">
                  <div className="order-config-item-icon">
                    <i className="ti ti-folders"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="order-config-label">Program</div>
                    <div className="order-config-value">
                      {orderFilter?.program || "-"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-xl-4">
                <div className="order-config-item h-100">
                  <div className="order-config-item-icon">
                    <i className="ti ti-building"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="order-config-label">Department</div>
                    <div className="order-config-value">
                      {orderFilter?.department || "-"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-xl-4">
                <div className="order-config-item h-100">
                  <div className="order-config-item-icon">
                    <i className="ti ti-package"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="order-config-label">Package</div>
                    <div className="order-config-value">
                      {orderFilter?.package || "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (   
        <CommonFilterSelect
          colClass="col-6 col-sm-4 col-md-3 col-xl-2"
          handleGetFilters={(data) => {
            console.log("Selected filter data:", data);
            setFilterData(data);
          }}
        />
      )}

      <div className="mt-4 pt-2">
        {orderFilter?.package_description && (
          <>
            <div className=" mb-2 fw-semibold">Package Scope</div>
            <div className=" p-2 text-dark fw-semibold border rounded-3">
              {orderFilter?.package_description}
            </div>
          </>
        )}

        <div className="mt-3">
          <div className="fw-semibold text-dark mb-3 pt-2">Step 2</div>
          <form onSubmit={handleFormSubmit}>
            <div className="card">
              <div className="card-header">
                <h5>Applicant Details</h5>
              </div>
              <div className="card-body p-3 row my-0 gx-2 ">
                <InputField<any>
                  {...sharedProps}
                  label="First Name"
                  name="first_name"
                  className="text-capitalize"
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="Middle Name"
                  name="middle_name"
                  className="text-capitalize"
                  disabled={loadingCreate}
                />

                <InputField<any>
                  {...sharedProps}
                  label="Last Name"
                  name="last_name"
                  className="text-capitalize"
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  type="email"
                  name="applicant_email"
                  label="Applicant Email ID"
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="Applicant Mobile Number"
                  name="applicant_mobile"
                  inputMode="numeric"
                  maxLength={10}
                  disabled={loadingCreate}
                  required
                />

                <InputDateField
                  {...sharedProps}
                  label="Date of Birth"
                  name="dob"
                  onChange={handleDateChange}
                  disabled={loadingCreate}
                  required
                />

                <div className="col-6 col-md-4 mb-3">
                  <label
                    htmlFor="gender"
                    className="form-label fw-bold text-dark"
                  >
                    Gender <span className="text-danger">*</span>
                  </label>

                  <select
                    name="gender"
                    value={formData.gender || ""}
                    onChange={handleChange}
                    className="form-select form-select-sm mb-1"
                    disabled={loadingCreate}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>

                  {errors?.gender && <ErrorMessage message={errors?.gender} />}
                </div>

                <InputField<any>
                  {...sharedProps}
                  label="Father Name"
                  name="parent_name"
                  className="text-capitalize"
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="UAN No."
                  name="uan_no"
                  inputMode="numeric"
                  maxLength={12}
                  disabled={loadingCreate}
                  // required
                />
                <InputField<any>
                  {...sharedProps}
                  label="PAN No."
                  name="pan_no"
                  className="text-uppercase"
                  maxLength={10}
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="Aadhar Card Number"
                  name="aadharNumber"
                  inputMode="numeric"
                  maxLength={12}
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="Aadhar Address"
                  name="address1"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                  required
                />
                <InputField<any>
                  {...sharedProps}
                  label="Aadhar Address Pincode"
                  name="aadhar_pincode"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="Applicant Address"
                  name="address2"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                  // required
                />
                <InputField<any>
                  {...sharedProps}
                  label="Applicant Address Pincode"
                  name="address_pincode"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                  // required
                />

                <InputField<any>
                  {...sharedProps}
                  label="Applicant Registration Number (CRN)"
                  name="crn_no"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                />

                <InputField<any>
                  {...sharedProps}
                  label="Candidate ID"
                  name="hrmsId"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="Worker ID"
                  name="employeeId"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                />

                <InputDateField
                  {...sharedProps}
                  label="Hire Date"
                  name="joiningDate"
                  onChange={handleDateChange}
                  disabled={loadingCreate}
                  required
                />

                <InputField<any>
                  {...sharedProps}
                  label="SPOC Name"
                  name="spocName"
                  colClass="col-12 col-md-4"
                  disabled={loadingCreate}
                  required
                />
              </div>
              <div className="card-footer text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loadingCreate}
                >
                  {loadingCreate ? "Sending..." : "Send Invite"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SingleAssign;
